/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { JobTitleResponse } from 'src/pages/CandidateJobTitles/types';
import QueryKeys from '../config';
import API from '../../../network';

const useJobTypes = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.JOB_TYPES,
    queryFn: async () => API.getInstance().fetchJobTitles().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: undefined,
    enabled,
  });

  const jobTypesOptions: { label: string; value: string }[] = React.useMemo(
    () => data?.map((option: JobTitleResponse) => (
      { label: option.value, value: option.id.toString() })) || [],
    [data],
  );

  return {
    jonTypesLoading: isLoading,
    jobTypesOptions,
    data,
    error,
    fetchJobTypes: refetch,
  };
};

export {
  useJobTypes,
};
